import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const NotificationsRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.notifications.route,
      lazy: () => import("@pages/panelPages/notifications/notifications"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.notifDetail", [], "index");
        return {};
      },
    },
    permissions: [
      "patient",
      "admin",
      "super-admin",
      "doctor",
      "local-admin",
      "staff",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
